import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * An ask the launcher hands to a full Livy page. It travels in router state, never the URL: a link from
 * outside the app cannot carry it, so nobody can send a Livy turn as the person who clicks a link.
 */
export function usePageAsk() {
  const _useLocation = useLocation(),
    pathname = _useLocation.pathname,
    state = _useLocation.state;
  const navigate = useNavigate();
  const ask = state === null || state === void 0 ? void 0 : state.livyAsk;
  const clear = useCallback(() => navigate(pathname, {
    replace: true,
    state: null
  }), [navigate, pathname]);
  return [typeof ask === 'string' && ask ? ask : null, clear];
}